import { sendGTMData } from 'utils/gtm.js'
import StrumentoCard from 'components/card/StrumentoCard'
import RaccoltaCard from 'components/card/RaccoltaCard'
import LezioneCard from 'components/card/LezioneCard'
import ArticoloCard from 'components/card/ArticoloCard'
import AutoreCard from 'components/card/AutoreCard'
import GenericCard from 'components/card/GenericCard'
import { getWaLabel, getCookie } from 'utils'
import React from 'react'
import { connectHitInsights } from 'react-instantsearch-dom'
import aa from 'utils/algolia-search-insights'

const Hit = ({
  hit,
  insights,
  query,
  horizontal = false,
  waAction = '',
  position = 0,
  parentList = '',
}) => {
  let item = hit

  if (!item.preview_image) item['preview_image'] = item['preview_image_absolute_url']
  if (!item.main_image) item['main_image'] = item['main_image_absolute_url']

  const handleGTM = (query) => {
    // solo se risultato di una ricerca, non nel listing
    if (query) {
      sendGTMData({
        event: 'GAevent',
        eventID: '08',
        eventCategory: 'search',
        eventAction: waAction,
        eventLabel: getWaLabel(hit),
        moreInfo: hit.titolo.toGTMFormat(),
      })
    }
  }

  function renderCard(hit) {
    switch (hit.model_class) {
      case 'strumento':
        return (
          <StrumentoCard
            strumento={hit}
            horizontal={horizontal}
            position={position}
            parentList={parentList}
          />
        )
      case 'raccolta':
        return (
          <RaccoltaCard
            raccolta={hit}
            horizontal={horizontal}
            position={position}
            parentList={parentList}
          />
        )
      case 'articolo':
        return (
          <ArticoloCard
            articolo={hit}
            horizontal={horizontal}
            position={position}
            parentList={parentList}
          />
        )
      case 'lezione':
        return (
          <LezioneCard
            articolo={hit}
            horizontal={horizontal}
            position={position}
            parentList={parentList}
          />
        )
      case 'autore':
        return (
          <AutoreCard
            autore={hit}
            horizontal={horizontal}
            position={position}
            parentList={parentList}
          />
        )
      default:
        return (
          <GenericCard
            item={hit}
            horizontal={horizontal}
            position={position}
            parentList={parentList}
          />
        )
    }
  }

  return (
    <div
      className="ais-Hits-item"
      onClick={() => {
        handleGTM(query)
        insights('clickedObjectIDsAfterSearch', {
          eventName: 'Card Clicked',
          userToken: `user-${getCookie('sessionid')}`,
        })
      }}
    >
      {renderCard(item)}
    </div>
  )
}

export default connectHitInsights(aa)(Hit)
